import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import BenefitTile from './pricing-tile';
import { SectionHeading } from './pricing-tile.styled';
import { BenefitsContainer, HighlevelBenefitsContainer } from './pricing.styled';

const pricingConfig = [
  {
    id: 'terminal',
    title: 'Terminal',
    icon: 'Terminal',
    description: '1.75% + 45p per in-person transaction',
  },
  {
    id: 'payment-links',
    title: 'Payment links',
    icon: 'Membership',
    description: '2.99% + 45p per transaction',
  },
  {
    id: 'card-collection',
    title: 'Card collection',
    icon: 'CardSuccess',
    description: '25p per online card collection',
  },
  {
    id: 'wallet-top-up',
    title: 'Wallet top-ups',
    icon: 'CardWallet',
    description: '2.5% + 25p processing fee per top-up',
  },
];

export function Pricing({ config }) {
  return (
    <WidthContainer>
      <HighlevelBenefitsContainer>
        <SectionHeading>Pricing that won’t break the bank</SectionHeading>

        <BenefitsContainer>
          {pricingConfig.map((tile) => (
            <BenefitTile key={tile.id} benefit={tile} />
          ))}
        </BenefitsContainer>
        <p>All fees exclude VAT</p>
      </HighlevelBenefitsContainer>
    </WidthContainer>
  );
}
